import React, { useEffect, useState } from 'react';

import logJsUnexpected from '@zr/utilities/telemetry/logJsUnexpected';

import { ImportTranslationsFn, Translations, ZRGlobal, ZRGlobalMicrofrontend } from './d';
import { TranslationsProvider } from './TranslationContext';
import { parseTranslationsFile } from './util';

declare const zr: ZRGlobal | ZRGlobalMicrofrontend;

export const I18NLoader: React.FC<{
  importTranslation: ImportTranslationsFn,
  microfrontendName?: string,
  children?: React.ReactChildren | JSX.Element,
}> = ({
  importTranslation,
  microfrontendName,
  children,
}) => {
  const [status, setStatus] = useState<'error' | 'loading' | 'ready'>('loading');
  const [translations, setTranslations] = useState<Record<string, string>>();
  const translationsModel: Translations = microfrontendName
    ? (zr as ZRGlobalMicrofrontend).page.translations[microfrontendName]
    : (zr as ZRGlobal).page.translations;

  useEffect(() => {
    (async () => {
      if (status === 'loading') {
        try {
          const fetchedTranslations = await importTranslation();

          const parsedTranslations = parseTranslationsFile(fetchedTranslations.default);

          setTranslations(parsedTranslations);
          setStatus('ready');
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Failed to load translations!', error);
          logJsUnexpected('missing_translation', 'all');
          setStatus('error');
        }
      }
    })();
  }, [status, importTranslation]);

  if (status === 'loading') {
    return (
      <div className="translations_loading" aria-live="polite" aria-label={translationsModel.C_I18N_LOADING} />
    );
  }

  if (status === 'ready' && translations) {
    return (
      <TranslationsProvider value={{ translations, prefix: '' }}>
        {children}
      </TranslationsProvider>
    );
  }

  // status === 'error' || !translations
  return <div className="translations_error" aria-live="polite" aria-label={translationsModel.C_I18N_ERROR} />;
};

export default I18NLoader;
